<p>contract-product-create-modal works!</p>
